import React from "react";

import { useIntl } from "react-intl";
import { useTheme } from "styled-components";

import { APP_NAME } from "Constants/documentationUrls";
import Illustration from "Vendor_resources/images/empty-vouchers.svg";
import IllustrationDark from "Vendor_resources/images/empty-vouchers_dark.svg";

import Form from "../Form";

import * as S from "./EmptyVouchers.styles";

function EmptyVouchers() {
  const intl = useIntl();
  const theme = useTheme();

  return (
    <S.Wrapper>
      <img
        src={theme.name === "dark" ? IllustrationDark : Illustration}
        alt={intl.formatMessage({ id: "voucher.empty.title" })}
        style={{ width: "80px", height: "80px" }}
      />
      <S.Title tag="h2">
        {intl.formatMessage({ id: "voucher.empty.title" })}
      </S.Title>

      <S.Intro>
        {intl.formatMessage(
          { id: "voucher.empty.intro" },
          {
            br: <br />,
            appName: APP_NAME
          }
        )}
      </S.Intro>
      <Form cancelable={false} reloadList={true} />
    </S.Wrapper>
  );
}

export default EmptyVouchers;
